// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kc3eRmw9XAgdTU {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--ds-space-300, 24px);
  background-color: var(--ds-background-accent-yellow-subtlest, rgba(255, 250, 229, 0.4));
  text-align: left;
  gap: 14px;
}
.e76W5x8epmAbYS {
  padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-050, 4px) var(--ds-space-075, 6px);
}
.e76W5x8epmAbYS svg {
  width: auto;
  height: 16px;
}
.e76W5x8epmAbYS svg path {
  fill: var(--ds-background-accent-yellow-subtle, #ffc400);
}
.lrVt0g0y5C3bR9 {
  display: flex;
  padding-bottom: var(--ds-space-075, 6px);
  line-height: 16px;
}
.BPz2_7MrAek6Pi {
  padding-right: var(--ds-space-050, 4px);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 20px;
}
.WOskhZ1SqeVCaz {
  margin-bottom: 14px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.HPRnhoflW2M2QS {
  display: inline-block;
}
.HPRnhoflW2M2QS a,
.HPRnhoflW2M2QS > span {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-150, 12px) 14px var(--ds-space-150, 12px);
  transition: all 250ms ease-out;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}
.HPRnhoflW2M2QS a span,
.HPRnhoflW2M2QS > span span {
  display: inline-block;
}
.HPRnhoflW2M2QS a svg,
.HPRnhoflW2M2QS > span svg {
  display: inline-block;
  margin-top: var(--ds-space-025, 2px);
  margin-left: var(--ds-space-100, 8px);
  transform: translate3d(0px, 0, 0);
  transition: transform 250ms ease-out;
}
.kc3eRmw9XAgdTU div > a {
  padding: var(--ds-space-150, 12px) 14px;
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-input, #ffffff);
  font-size: 16px;
  line-height: 24px;
}
.kc3eRmw9XAgdTU div > a > span {
  color: var(--ds-text, #172b4d);
}
.HPRnhoflW2M2QS a:hover,
.HPRnhoflW2M2QS > span:hover {
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-bolder, rgba(137, 147, 164, 0.1));
  text-decoration: none;
}
.HPRnhoflW2M2QS a:hover svg,
.HPRnhoflW2M2QS > span:hover svg {
  transform: translate3d(3px, 0, 0);
}
.HPRnhoflW2M2QS a:active,
.HPRnhoflW2M2QS > span:active {
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-subtler, rgba(122, 134, 154, 0.1));
  color: var(--ds-text-subtlest, #626f86);
}
.HPRnhoflW2M2QS a:focus,
.HPRnhoflW2M2QS > span:focus {
  box-shadow: 0 0 0 4px var(--ds-background-accent-gray-subtle, rgba(137, 147, 164, 0.4));
}
.kc3eRmw9XAgdTU div > a:hover {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
.kc3eRmw9XAgdTU div > a:active {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
.kc3eRmw9XAgdTU div > a:focus {
  border: 1px solid var(--ds-border-accent-yellow, #ffc400);
  background-color: var(--ds-background-accent-yellow-subtler, #fffae5);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `kc3eRmw9XAgdTU`,
	"bannerIcon": `e76W5x8epmAbYS`,
	"bannerTitleContainer": `lrVt0g0y5C3bR9`,
	"bannerTitle": `BPz2_7MrAek6Pi`,
	"bannerDescription": `WOskhZ1SqeVCaz`,
	"linkButton": `HPRnhoflW2M2QS`
};
export default ___CSS_LOADER_EXPORT___;
